import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import {
  reloadYardByName,
  userByActiveByLastName,
} from "../../../graphql/queries";

import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  Button,
  Datagrid,
  ListContextProvider,
  SimpleForm,
  TextField,
  TextInput,
  Title,
  Toolbar,
  useList,
  useListContext,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { EmailIcon } from "../../../components/common/iconography";
import { Pagination } from "../../../components/Pagination";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import {
  ReloadYardStatus,
  SubscriptionStatus,
  UserStatus,
} from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    flex: "1",
    width: "100%",
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    "& > *": {
      margin: theme.spacing(0),
      padding: theme.spacing(0),
    },
  },
  cardHeader: {
    margin: theme.spacing(2),
  },
}));

// const ln2br = (text) => text.replace(/(?:\r\n|\r|\n)/g, '<br>');

const PaginationToolbar = (props) => {
  const listContext = useListContext(props);

  return (
    <Grid container direction="row" spacing={1} alignItems="center">
      <Grid item xs={4}>
        <Typography>
          {listContext?.selectedIds?.length > 0 ? (
            `${listContext.selectedIds.length} selected`
          ) : (
            <>&nbsp;</>
          )}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Pagination {...props} {...listContext} />
      </Grid>
    </Grid>
  );
};

const sendEmail = (to, cc, subject, message) => {
  return API.post("transREST", "/sendEmail", {
    body: {
      to: to,
      cc: cc,
      bcc: "support@transloads.co",
      subject: subject,
      template: "emailTemplate.html",
      htmlContent: `<div align="left" style="white-space: normal; text-align: left">
                    ${message}
                </div>`,
    },
  });
};

export const EmailAnnouncement = (props) => {
  const classes = useStyles();
  const notify = useNotify();
  const [sending, setSanding] = useState(false);
  const [reloadYards, setReloadYards] = useState([]);
  const [users, setUsers] = useState([]);
  const defaultSort = { field: "name", order: "ASC" };
  const defaultPerPage = 25;

  useEffect(() => {
    getYardData();
  }, []);

  const getYardData = async () => {
    try {
      debugger;
      const input = { active: "true", limit: 1000 };
      let response = await API.graphql(
        graphqlOperation(reloadYardByName, input)
      );
      // filter for yards with active subscription
      let yards = response.data.reloadYardByName.items || [];
      // send message to TRIALING, ACTIVE, and SUSPENDED yards
      yards = yards.filter(
        (yard) =>
          yard?.status !== ReloadYardStatus.CANCELLED &&
          yard?.status !== ReloadYardStatus.TERMINATED
      );
      setReloadYards(yards);

      // forEach reloadYard, get active users
      const userResults = await Promise.allSettled(
        yards.map((yard) =>
          API.graphql(
            graphqlOperation(userByActiveByLastName, {
              reloadYardId: yard.id,
              activeLastName: { beginsWith: { active: "true" } },
              limit: 1000,
            })
          )
        )
      );

      const aggregatedUsers = userResults.reduce((acc, res) => {
        if (res.status === "fulfilled") {
          const items = res.value?.data?.userByActiveByLastName?.items || [];
          return acc.concat(items);
        }
        return acc;
      }, []);

      setUsers(aggregatedUsers);
    } catch (error) {
      logError("EmailAnnouncement:getYards", error, notify);
    }
  };

  const sendEmails = async (form, listContext) => {
    console.clear();
    setSanding(true);
    const formState = form.getState();
    let yardList = reloadYards;
    debugger;

    try {
      if (listContext?.selectedIds?.length > 0) {
        yardList = reloadYards.filter((yard) => {
          return listContext.selectedIds.some((f) => {
            return f === yard.id;
          });
        });
      }

      const promiseList = [];
      yardList.forEach((yard) => {
        const userList = users.filter((user) => {
          return (
            user.reloadYardId === yard.id &&
            user.active === "true" &&
            user.status === UserStatus.APPROVED &&
            !user.unsubscribed
          );
        });
        const ccList = userList.map((user) => user.email);

        promiseList.push(
          sendEmail(
            yard.email,
            ccList,
            formState.values.subject,
            formState.values.message
          )
        );
      });

      const results = await Promise.allSettled(promiseList);
      const errors = results.filter(
        (res) => res.status === "rejected" || res.value?.error
      );
      if (errors.length > 0)
        logError("EmailAnnouncement:sendEmails", errors, notify);
      else notify(`Emails sent successfully.`);
    } catch (error) {
      logError("EmailAnnouncement:sendEmails", error, notify);
    } finally {
      setSanding(false);
    }
  };

  const listContext = useList({
    ...props,
    data: reloadYards || [],
    ids: reloadYards?.map(({ id }) => id) || [],
    loaded: true,
    sort: defaultSort,
    perPage: defaultPerPage,
    basePath: "/reloadYards",
    resource: "reloadYards",
  });

  const CreateToolbar = (props) => {
    const form = useForm();

    return (
      <Toolbar {...props}>
        <Button
          label="Send Email"
          variant="contained"
          color="primary"
          disabled={sending}
          onClick={() => sendEmails(form, listContext)}
        />
      </Toolbar>
    );
  };

  return (
    <SimpleForm
      variant="outlined"
      submitOnEnter={false}
      toolbar={<CreateToolbar />}
    >
      <Title title={<ForceTitle title="Email Announcement" />} />
      <Card className={classes.card}>
        <CardHeader
          title={<Typography variant="h6">Email Announcement</Typography>}
          avatar={
            <Avatar>
              <EmailIcon />
            </Avatar>
          }
          action={<BackButton basePath="/announcements" />}
          className={classes.cardHeader}
        />
        <CardContent className={classes.card}>
          <Grid container direction="row" spacing={1} fullWidth>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextInput
                    source="subject"
                    label="Subject"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    source="message"
                    label="HTML Message"
                    variant="outlined"
                    placeholder="
                      <p>We are writing to inform you of a <b>new release</b>
                      <p>Best,<br>
                      <b>transloads.co team</b></p>"
                    multiline
                    minRows="10"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ListContextProvider value={listContext}>
                <Datagrid
                  rowClick={false}
                  basePath="/reloadYards"
                  hasBulkActions={true}
                >
                  <TextField source="name" label="Name" />,
                </Datagrid>
                <PaginationToolbar {...props} />
              </ListContextProvider>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </SimpleForm>
  );
};
